function t(e) {
  return Object.keys(e);
}
const r = {
  "badge/believer": "#374151",
  "badge/free": "#29a3fa",
  "badge/pro": "#29a3fa",
  "block/callout/background/blue": "#f0f9ff",
  "block/callout/background/green": "#fbfef1",
  "block/callout/background/grey": "#f9f9f9",
  "block/callout/background/magenta": "#fefaff",
  "block/callout/background/orange": "#fff7ee",
  "block/callout/background/purple": "#f9f7ff",
  "block/callout/background/red": "#fff4f5",
  "block/callout/background/teal": "#eefffd",
  "block/callout/background/yellow": "#fdfcf4",
  "block/callout/icon/blue": "#53b2ef",
  "block/callout/icon/green": "#22bf07",
  "block/callout/icon/grey": "#cdcdcd",
  "block/callout/icon/magenta": "#cc4187",
  "block/callout/icon/orange": "#ffae63",
  "block/callout/icon/purple": "#7c3aed",
  "block/callout/icon/red": "#c83030",
  "block/callout/icon/teal": "#448e86",
  "block/callout/icon/yellow": "#fde047",
  "block/notSupportedBlock/background": "#ffffff",
  "button/innerBlackBorder": "#00000012",
  "button/badgesColor": "#ed3f3f",
  "button/checkBox": "#1e96eb",
  "button/emptyIconBackground": "#0000000d",
  "button/error": "#ed3f3f",
  "button/iconButtonSolid": "#ffffff",
  "button/primary": "#1e96eb",
  "button/pureWhiteText": "#ffffff",
  "button/secondary": "#ffffff",
  "button/success": "#44b931",
  "button/grabber/select": "#00000038",
  "button/grabber/default": "#0000001a",
  "button/sidebarButton/background": "#ffffff08",
  "button/siderbarPrimary/background": "#ffffffab",
  "database/border": "#0000001a",
  "database/textSecondary": "#00000085",
  "dialog/bg": "#ffffff",
  "edgeless/frame/background/black": "#cdcdcd",
  "edgeless/frame/background/blue": "#e6f5ff",
  "edgeless/frame/background/green": "#f1fdf4",
  "edgeless/frame/background/grey": "#f3f3f3",
  "edgeless/frame/background/orange": "#ffebd5",
  "edgeless/frame/background/purple": "#ede9ff",
  "edgeless/frame/background/red": "#fce5e6",
  "edgeless/frame/background/teal": "#e2fdf9",
  "edgeless/frame/background/white": "#ffffff",
  "edgeless/frame/background/yellow": "#fffbd5",
  "edgeless/frame/border/active": "#1e96eb",
  "edgeless/frame/border/default": "#0000002b",
  "edgeless/frame/border/locked": "#00000085",
  "edgeless/frame/fontColor/font": "#000000f2",
  "edgeless/group/background/background": "#ffffff",
  "edgeless/group/border/active": "#1e96eb",
  "edgeless/group/border/borderHint": "#8fd1ff",
  "edgeless/group/border/hover": "#1e96eb",
  "edgeless/group/fontColor/active": "#1e96eb",
  "edgeless/group/fontColor/default": "#00000085",
  "edgeless/group/fontColor/hover": "#1e96eb",
  "edgeless/group/fontColor/rename": "#000000",
  "edgeless/line/black": "#000000",
  "edgeless/line/blue": "#29a3fa",
  "edgeless/line/green": "#3cbc36",
  "edgeless/line/grey": "#929292",
  "edgeless/line/magenta": "#e660a4",
  "edgeless/line/orange": "#ff8c38",
  "edgeless/line/purple": "#6e52df",
  "edgeless/line/red": "#e11e41",
  "edgeless/line/teal": "#5cc7ba",
  "edgeless/line/white": "#ffffff",
  "edgeless/line/yellow": "#facc15",
  "edgeless/mindMap/line": "#000000",
  "edgeless/note/black": "#b3b3b3",
  "edgeless/note/blue": "#ceecff",
  "edgeless/note/green": "#c9f8c1",
  "edgeless/note/grey": "#e6e6e6",
  "edgeless/note/magenta": "#ffdaed",
  "edgeless/note/orange": "#ffc58f",
  "edgeless/note/purple": "#ddd6fe",
  "edgeless/note/red": "#fbb7b7",
  "edgeless/note/teal": "#c7f8f2",
  "edgeless/note/white": "#ffffff",
  "edgeless/note/yellow": "#fde68a",
  "edgeless/shape/black": "#000000",
  "edgeless/shape/blue": "#9fd9ff",
  "edgeless/shape/green": "#9bda91",
  "edgeless/shape/grey": "#cdcdcd",
  "edgeless/shape/magenta": "#ffc0e0",
  "edgeless/shape/orange": "#ffae63",
  "edgeless/shape/purple": "#d7cdff",
  "edgeless/shape/red": "#fecdd1",
  "edgeless/shape/teal": "#8be7dc",
  "edgeless/shape/white": "#ffffff",
  "edgeless/shape/yellow": "#fde047",
  "icon/disable": "#b3b3b3",
  "icon/primary": "#7a7a7a",
  "icon/secondary": "#b3b3b3",
  "icon/tertiary": "#cdcdcd",
  "label/blue": "#e6f5ff",
  "label/green": "#dcfdd7",
  "label/grey": "#e6e6e6",
  "label/magenta": "#ffecf6",
  "label/orange": "#ffebd5",
  "label/purple": "#ede9ff",
  "label/red": "#fce5e6",
  "label/teal": "#d7fbf6",
  "label/text": "#00000085",
  "label/white": "#f5f5f5",
  "label/yellow": "#fef3c7",
  "layer/border": "#e6e6e6",
  "layer/toolTips": "#141414",
  "layer/insideBorder/black": "#0000001a",
  "layer/insideBorder/primary": "#1e96eb",
  "layer/insideBorder/white": "#ffffff8f",
  "layer/background/codeBlock": "#f9f9f9",
  "layer/background/error": "#fff1f1",
  "layer/background/hoverOverlay": "#0000000d",
  "layer/background/modal": "#000000b2",
  "layer/background/overlayPanel": "#ffffff",
  "layer/background/primary": "#ffffff",
  "layer/background/processing": "#eef2ff",
  "layer/background/secondary": "#f5f5f5",
  "layer/background/success": "#f1fdf4",
  "layer/background/tertiary": "#f3f3f3",
  "layer/background/translucentUI": "#ffffffb8",
  "layer/background/warning": "#fff7ee",
  "loading/background": "#0000001a",
  "loading/foreground": "#1e96eb",
  "others/warnLabel/black": "#000000",
  "others/warnLabel/yellow": "#facc15",
  "status/error": "#ed3f3f",
  "status/success": "#44b931",
  "switch/buttonBackground/active": "#ffffff",
  "switch/buttonBackground/hover": "#0000000d",
  "switch/fontColor/primary": "#141414",
  "switch/fontColor/secondary": "#7a7a7a",
  "switch/fontColor/tertiary": "#929292",
  "switch/iconColor/active": "#565656",
  "switch/iconColor/default": "#929292",
  "switch/switchBackground/background": "#f3f3f3",
  "tab/divider/divider": "#00000012",
  "tab/divider/indicator": "#1e96eb",
  "tab/fontColor/active": "#141414",
  "tab/fontColor/default": "#7a7a7a",
  "tab/fontColor/hover": "#141414",
  "tab/iconColor/active": "#565656",
  "tab/iconColor/default": "#929292",
  "tab/iconColor/hover": "#565656",
  "tab/tabBackground/active": "#00000012",
  "tab/tabBackground/default": "#00000008",
  "text/disable": "#7a7a7a",
  "text/emphasis": "#1e96eb",
  "text/link": "#035f9f",
  "text/listDotAndNumber": "#0077cb",
  "text/placeholder": "#929292",
  "text/primary": "#141414",
  "text/pureWhite": "#ffffff",
  "text/secondary": "#7a7a7a",
  "text/tertiary": "#929292",
  "text/highlight/border": "#00000038",
  "text/highlight/bg/blue": "#daf0ff",
  "text/highlight/bg/green": "#f0fccb",
  "text/highlight/bg/grey": "#e6e6e6",
  "text/highlight/bg/magenta": "#ffecf6",
  "text/highlight/bg/orange": "#ffebd5",
  "text/highlight/bg/purple": "#ede9ff",
  "text/highlight/bg/red": "#fce5e6",
  "text/highlight/bg/teal": "#c7f8f2",
  "text/highlight/bg/yellow": "#fff9b6",
  "text/highlight/fg/blue": "#003c67",
  "text/highlight/fg/green": "#225c18",
  "text/highlight/fg/grey": "#7a7a7a",
  "text/highlight/fg/magenta": "#941555",
  "text/highlight/fg/orange": "#db7123",
  "text/highlight/fg/purple": "#7c3aed",
  "text/highlight/fg/red": "#c83030",
  "text/highlight/fg/teal": "#0e4841",
  "text/highlight/fg/yellow": "#ac7400",
  "toast/cardLayer/second": "#f9f9f9",
  "toast/cardLayer/third": "#f5f5f5",
  "toast/iconState/error": "#ed3f3f",
  "toast/iconState/regular": "#0077cb",
  "toast/iconState/success": "#44b931",
  "toast/overlay/secondary": "#00000008",
  "toast/overlay/tertiary": "#0000000d",
  "toggle/background": "#1e96eb",
  "toggle/backgroundDisable": "#b3b3b3",
  "toggle/backgroundOff": "#929292",
  "toggle/foreground": "#ffffff",
  "toggle/foregroundDisable": "#e6e6e6",
  "tooltips/background": "#000000",
  "tooltips/foreground": "#ffffff",
  "tooltips/secondaryBackground": "#ffffff2b"
}, d = {
  "badge/believer": "#374151",
  "badge/free": "#29a3fa",
  "badge/pro": "#29a3fa",
  "block/callout/background/blue": "#002742",
  "block/callout/background/green": "#192e06",
  "block/callout/background/grey": "#414141",
  "block/callout/background/magenta": "#5f0a35",
  "block/callout/background/orange": "#451a02",
  "block/callout/background/purple": "#1e1b4b",
  "block/callout/background/red": "#460606",
  "block/callout/background/teal": "#0e4841",
  "block/callout/background/yellow": "#321a04",
  "block/callout/icon/blue": "#2f94d5",
  "block/callout/icon/green": "#22bf07",
  "block/callout/icon/grey": "#cdcdcd",
  "block/callout/icon/magenta": "#cc4187",
  "block/callout/icon/orange": "#d97705",
  "block/callout/icon/purple": "#7c3aed",
  "block/callout/icon/red": "#c83030",
  "block/callout/icon/teal": "#5cc7ba",
  "block/callout/icon/yellow": "#e0aa00",
  "block/notSupportedBlock/background": "#000000",
  "button/innerBlackBorder": "#ffffff17",
  "button/badgesColor": "#ed3f3f",
  "button/checkBox": "#1e96eb",
  "button/emptyIconBackground": "#ffffff0d",
  "button/error": "#ed3f3f",
  "button/iconButtonSolid": "#252525",
  "button/primary": "#1e96eb",
  "button/pureWhiteText": "#ffffff",
  "button/secondary": "#000000",
  "button/success": "#44b931",
  "button/grabber/select": "#ffffff",
  "button/grabber/default": "#ffffff",
  "button/sidebarButton/background": "#ffffff08",
  "button/siderbarPrimary/background": "#0000002b",
  "database/border": "#ffffff21",
  "database/textSecondary": "#ffffff8f",
  "dialog/bg": "#ffffff",
  "edgeless/frame/background/black": "#cdcdcd",
  "edgeless/frame/background/blue": "#e6f5ff",
  "edgeless/frame/background/green": "#f1fdf4",
  "edgeless/frame/background/grey": "#f3f3f3",
  "edgeless/frame/background/orange": "#ffebd5",
  "edgeless/frame/background/purple": "#ede9ff",
  "edgeless/frame/background/red": "#fce5e6",
  "edgeless/frame/background/teal": "#e2fdf9",
  "edgeless/frame/background/white": "#ffffff",
  "edgeless/frame/background/yellow": "#fffbd5",
  "edgeless/frame/border/active": "#1e96eb",
  "edgeless/frame/border/default": "#ffffff2b",
  "edgeless/frame/border/locked": "#ffffff8f",
  "edgeless/frame/fontColor/font": "#000000f2",
  "edgeless/group/background/background": "#ffffff",
  "edgeless/group/border/active": "#1e96eb",
  "edgeless/group/border/borderHint": "#8fd1ff",
  "edgeless/group/border/hover": "#1e96eb",
  "edgeless/group/fontColor/active": "#1e96eb",
  "edgeless/group/fontColor/default": "#ffffff8f",
  "edgeless/group/fontColor/hover": "#1e96eb",
  "edgeless/group/fontColor/rename": "#000000",
  "edgeless/line/black": "#000000",
  "edgeless/line/blue": "#29a3fa",
  "edgeless/line/green": "#3cbc36",
  "edgeless/line/grey": "#929292",
  "edgeless/line/magenta": "#e660a4",
  "edgeless/line/orange": "#ff8c38",
  "edgeless/line/purple": "#6e52df",
  "edgeless/line/red": "#ed3f3f",
  "edgeless/line/teal": "#5cc7ba",
  "edgeless/line/white": "#ffffff",
  "edgeless/line/yellow": "#facc15",
  "edgeless/mindMap/line": "#ffffff",
  "edgeless/note/black": "#252525",
  "edgeless/note/blue": "#004b7b",
  "edgeless/note/green": "#3b5315",
  "edgeless/note/grey": "#565656",
  "edgeless/note/magenta": "#5f0a35",
  "edgeless/note/orange": "#843b06",
  "edgeless/note/purple": "#312e81",
  "edgeless/note/red": "#460606",
  "edgeless/note/teal": "#0e4841",
  "edgeless/note/white": "#000000",
  "edgeless/note/yellow": "#704200",
  "edgeless/shape/black": "#000000",
  "edgeless/shape/blue": "#84cfff",
  "edgeless/shape/green": "#9bda91",
  "edgeless/shape/grey": "#b3b3b3",
  "edgeless/shape/magenta": "#f58ec3",
  "edgeless/shape/orange": "#ffae63",
  "edgeless/shape/purple": "#a693f3",
  "edgeless/shape/red": "#fc7979",
  "edgeless/shape/teal": "#8be7dc",
  "edgeless/shape/white": "#ffffff",
  "edgeless/shape/yellow": "#fde047",
  "icon/disable": "#414141",
  "icon/primary": "#f3f3f3",
  "icon/secondary": "#cdcdcd",
  "icon/tertiary": "#565656",
  "label/blue": "#004b7b",
  "label/green": "#225c18",
  "label/grey": "#414141",
  "label/magenta": "#5f0a35",
  "label/orange": "#843b06",
  "label/purple": "#25136d",
  "label/red": "#460606",
  "label/teal": "#1c6b63",
  "label/text": "#ffffffab",
  "label/white": "#252525",
  "label/yellow": "#ac7400",
  "layer/border": "#414141",
  "layer/toolTips": "#e6e6e6",
  "layer/insideBorder/black": "#ffffff0d",
  "layer/insideBorder/primary": "#1e96eb",
  "layer/insideBorder/white": "#ffffff0d",
  "layer/background/codeBlock": "#252525",
  "layer/background/error": "#460606",
  "layer/background/hoverOverlay": "#ffffff17",
  "layer/background/modal": "#00000038",
  "layer/background/overlayPanel": "#252525",
  "layer/background/primary": "#141414",
  "layer/background/processing": "#002742",
  "layer/background/secondary": "#252525",
  "layer/background/success": "#1c3027",
  "layer/background/tertiary": "#565656",
  "layer/background/translucentUI": "#000000a6",
  "layer/background/warning": "#321a04",
  "loading/background": "#ffffffd1",
  "loading/foreground": "#0077cb",
  "others/warnLabel/black": "#000000",
  "others/warnLabel/yellow": "#facc15",
  "status/error": "#9f2d2d",
  "status/success": "#1d9c07",
  "switch/buttonBackground/active": "#414141",
  "switch/buttonBackground/hover": "#ffffff0d",
  "switch/fontColor/primary": "#e6e6e6",
  "switch/fontColor/secondary": "#929292",
  "switch/fontColor/tertiary": "#7a7a7a",
  "switch/iconColor/active": "#cdcdcd",
  "switch/iconColor/default": "#7a7a7a",
  "switch/switchBackground/background": "#252525",
  "tab/divider/divider": "#ffffff21",
  "tab/divider/indicator": "#1e96eb",
  "tab/fontColor/active": "#141414",
  "tab/fontColor/default": "#929292",
  "tab/fontColor/hover": "#141414",
  "tab/iconColor/active": "#cdcdcd",
  "tab/iconColor/default": "#7a7a7a",
  "tab/iconColor/hover": "#cdcdcd",
  "tab/tabBackground/active": "#ffffff21",
  "tab/tabBackground/default": "#ffffff0d",
  "text/disable": "#565656",
  "text/emphasis": "#29a3fa",
  "text/link": "#7ac8ff",
  "text/listDotAndNumber": "#4ab1fa",
  "text/placeholder": "#565656",
  "text/primary": "#e6e6e6",
  "text/pureWhite": "#ffffff",
  "text/secondary": "#929292",
  "text/tertiary": "#7a7a7a",
  "text/highlight/border": "#ffffff3b",
  "text/highlight/bg/blue": "#002742",
  "text/highlight/bg/green": "#192e06",
  "text/highlight/bg/grey": "#414141",
  "text/highlight/bg/magenta": "#5f0a35",
  "text/highlight/bg/orange": "#843b06",
  "text/highlight/bg/purple": "#2e1065",
  "text/highlight/bg/red": "#460606",
  "text/highlight/bg/teal": "#0e4841",
  "text/highlight/bg/yellow": "#321a04",
  "text/highlight/fg/blue": "#2f94d5",
  "text/highlight/fg/green": "#9bda91",
  "text/highlight/fg/grey": "#565656",
  "text/highlight/fg/magenta": "#f37fba",
  "text/highlight/fg/orange": "#ffae63",
  "text/highlight/fg/purple": "#9681ef",
  "text/highlight/fg/red": "#fc7979",
  "text/highlight/fg/teal": "#448e86",
  "text/highlight/fg/yellow": "#facc15",
  "toast/cardLayer/second": "#252525",
  "toast/cardLayer/third": "#252525",
  "toast/iconState/error": "#ed3f3f",
  "toast/iconState/regular": "#035f9f",
  "toast/iconState/success": "#44b931",
  "toast/overlay/secondary": "#0000000d",
  "toast/overlay/tertiary": "#00000008",
  "toggle/background": "#0077cb",
  "toggle/backgroundDisable": "#414141",
  "toggle/backgroundOff": "#565656",
  "toggle/foreground": "#fffffffa",
  "toggle/foregroundDisable": "#929292",
  "tooltips/background": "#414141",
  "tooltips/foreground": "#ffffff",
  "tooltips/secondaryBackground": "#ffffff2b"
};
function o(e) {
  return `--affine-${e.split("/").join("-")}`;
}
function l(e) {
  const f = {};
  return t(e).forEach((a) => {
    f[o(a)] = e[a];
  }), f;
}
const g = l(r), c = l(d);
function b(e, f) {
  return `var(${o(e)}${f ? `, ${f}` : ""})`;
}
export {
  b as cssVarV2,
  c as darkCssVariablesV2,
  g as lightCssVariablesV2
};
//# sourceMappingURL=index.js.map
